<template>
  <div class="main">
    <div class="font-size24 margin-bottom10">{{ userInfo.name }}</div>
    <div class="font-size16 margin-bottom20">{{ $t('产品购买合同') }}&nbsp;{{ contractId }}</div>

    <div class="body">
      <subTable :tableData="invitationOrder"></subTable>
    </div>

    <div class="footer">
      <div class="pay—info">
        <div>
          {{ $t('本次总需支付金额：') }}<span class="font-size28">{{ invitationPrice }}</span
          >{{ $t('元') }}
        </div>

        <div>{{ $t('商务代表：') }}{{ creatorName }}</div>

        <div>{{ $t('联系电话：') }}{{ telphoneNo }}</div>
      </div>
      <div class="confirm-agree">
        <es-checkbox v-model="checked">{{ $t('我已阅读，同意此') }}</es-checkbox>
        <span class="confirm-agree-btn" @click="getContact">{{ $t('《e签宝产品购买协议》') }}</span>
      </div>
      <div :class="['confirm-bill-confirm', { disabled: !checked }]" @click="goNext">{{ $t('确认购买信息') }}</div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  data() {
    return {
      contractId: '',
      checked: false,
      invitationOrder: [],
      creatorName: '',
      telphoneNo: '',
      invitationPrice: '',
      payOrderId: '',
    }
  },
  components: {
    subTable: () => import('./components/subTable'),
  },
  methods: {
    getContact() {
      const { href } = this.$router.resolve({
        path: '/invitePayment/pdf',
        query: {
          contractId: this.contractId,
        },
      })
      window.open(href, '_blank')
    },
    // 下一步
    goNext() {
      if (!this.checked) {
        return
      }
      this.$router.push({
        path: '/invitePayment/pay',
        query: {
          invitationId: this.$route.query.invitationId,
          payOrderId: this.payOrderId,
        },
      })
    },
    viewContractFile() {
      this.$ajax(this.$url.viewContractFile(this.contractId), {}).then(res => {})
    },
    // 获取信息
    getInfo() {
      this.$ajax(this.$url.getPayInvitations(this.$route.query.invitationId), {}, false)
        .then(res => {
          this.getMarkOpened()
          this.invitationOrder = res.data.invitationOrder || []
          this.telphoneNo = res.data.telphoneNo
          this.invitationPrice = res.data.invitationPrice
          this.creatorName = res.data.creatorName
          this.contractId = res.data.contractId
          this.payOrderId = res.data.payOrderId
          this.viewContractFile()
        })
        .catch(err => {
          this.$alert(err.message, $t('提示'), {
            confirmButtonText: $t('确定'),
            type: 'error',
            dangerouslyUseHTMLString: true,
            showClose: false,
          }).then(() => {
            window.location.href = 'https://www.esign.cn/'
          })
        })
    },
    // 已经打开过邀约支付链接
    getMarkOpened() {
      this.$ajax(this.$url.getMarkOpened(this.$route.query.invitationId), {})
    },
  },
  created() {
    this.getInfo()
  },
}
</script>
<style lang="less" scoped>
// /deep/ .es-table th.is-leaf {
//   background: rgba(250, 250, 250, 1);
//   color: #333;
//   height: 30px;
//   line-height: 30px;
// }
.main {
  width: 1200px;
  margin: 0 auto;
  margin-top: 58px;
}
.font-size24 {
  font-size: 24px;
}
.margin-bottom10 {
  margin-bottom: 10px;
}
.margin-bottom20 {
  margin-bottom: 20px;
}
.font-size16 {
  font-size: 16px;
}
.font-size28 {
  font-size: 28px;
}

.confirm-agree {
  margin: 36px 0;
  &-btn {
    font-size: 14px;
    color: #1875f0;
    cursor: pointer;
  }
}
.pay—info {
  margin-top: 20px;
  color: #333;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > div {
    margin-bottom: 10px;
  }
}
.confirm-bill-confirm {
  width: 160px;
  height: 40px;
  cursor: pointer;
  background: rgba(230, 23, 23, 1);
  color: #fff;
  line-height: 40px;
  text-align: center;
}
.disabled {
  opacity: 0.5002;
  cursor: not-allowed;
}
.footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
